<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Checkbox examples" />
    <vc-layout :spacing="8">
      <vc-col :span="12" xs24>
        <h3 :class="titleStyle">No label, unchecked</h3>
        <vc-checkbox v-model="c1" name="c1" id="c1" />
        <div :class="['mt-16']">
          <code>v-model: {{ c1 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" xs24>
        <h3 :class="titleStyle">Label, checked</h3>
        <vc-checkbox v-model="c2" name="c2" id="c2">with label</vc-checkbox>
        <div :class="['mt-16']">
          <code>v-model: {{ c2 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" xs24>
        <h3 :class="titleStyle">Empty array model</h3>
        <vc-checkbox color="error" v-model="c3" name="c3" id="c3" value="martin">martin</vc-checkbox>
        <vc-checkbox color="info" v-model="c3" name="c4" id="c4" value="alex">alex</vc-checkbox>
        <vc-checkbox color="warning" v-model="c3" name="c5" id="c5" value="john">john</vc-checkbox>
        <div :class="['mt-16']">
          <code>v-model: {{ c3 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" xs24>
        <h3 :class="titleStyle">Number array model, color, left label</h3>
        <vc-checkbox label-position="left" v-model="c4" color="orange" name="c6" id="c6" :value="1">select one</vc-checkbox>
        <vc-checkbox label-position="left" v-model="c4" color="red" name="c7" id="c7" :value="2">select two</vc-checkbox>
        <vc-checkbox label-position="left" v-model="c4" color="deep-purple" name="c8" id="c8" :value="3">select three</vc-checkbox>
        <div :class="['mt-16']">
          <code>v-model: {{ c4 }}</code>
        </div>
      </vc-col>
      <vc-col :span="24">
        <h3 :class="titleStyle">Disabled</h3>
        <vc-checkbox label-position="left" color="green" id="c9" disabled name="c9" v-model="c5">disabled unchecked</vc-checkbox>
        <vc-checkbox label-position="left" color="green" id="c10" disabled name="c9" v-model="c6">disabled checked</vc-checkbox>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'CheckboxPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      titleStyle: ['title', 'font-grey', 'font-l-600'],
      c1: false,
      c2: true,
      c3: [],
      c4: [1, 2, 3],
      c5: false,
      c6: true
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/checkbox.vue